let style = {
    style1: {
        display: 'flex',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#7777774d',
        zIndex: '10'
    },
    style2: {
        position: 'relative',
        height: '590px',
        width: '480px',
        boxShadow: '0 0 16px 1px #747577',
        backgroundColor: 'white',
        borderRadius: '10px',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems:'center'
    },
    headerStyle: {
        position: 'absolute',
        top: '0',
        height: '110px',
        width: '100%',
        backgroundColor: '#dbd4d94d',
        display: 'flex',
        zIndex: '12',
        marginTop: '40px',
        marginRight: '20px',
        marginLeft: '20px',
        line1: {
            width: '100%',
            dispaly: 'flex',
            justifycontent: 'start'
        },
        line2: {
            width: '100%',
            paddingRight: '20px',
            marginTop: '-26px'
        },
        line3: {
            width: '100%',
            paddingRight: '20px',
            marginTop: '5px'
        },
        closeBtn: {
            border: 'none',
            backgroundColor: 'transparent',
            transform: 'rotate(45deg)',
            fontSize: '30px',
            position: 'relative',
            bottom: '41px',
            right: '2px',
            cursor: 'pointer',
            outline: 'none'
        }
    },

    contentStyle: {
        overflowY: 'scroll',
        width: '100%',
        height: '100%',
        marginTop: '150px',
        marginBottom: '85px',
        padding: '20px',
        paddingRight: '25px'
    },
    
    footerStyle: {
        position: 'absolute',
        bottom: '0',
        backgroundColor: '#dbd4d94d',
        width: '100%',
        marginBottom: '20px',
        marginTop: '20px',
        height: '45px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}

export default style

